import { AxiosResponse } from "axios"
import { TextEntryPoint } from "src/types/textEntryPoints"
import { WebchatEntryPointService } from "./webchatEntryPointService"

export interface ApiWebchatEntryPoints {
    createWebchatEntryPoint(entryPoint: TextEntryPoint): Promise<AxiosResponse>
    getAllWebchatEntryPoints(): Promise<AxiosResponse>
    getWebchatEntryPointById(entryPointId: string): Promise<AxiosResponse>
    updateWebchatEntryPoint(entryPoint: TextEntryPoint): Promise<AxiosResponse>
}

export const webchatEntryPointService = new WebchatEntryPointService();